import {
  Attribute as AttributeProp,
  AttributeType,
} from '@returnmates/client-core/src/graphql/generated/api'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo, useCallback } from 'react'
import { Field, useField } from 'react-final-form'

import useStyles from '../styles'
import Attribute from './Attribute'

function AttributesSettings() {
  const classes = useStyles({})
  const { input: attributes } = useField<Array<AttributeProp>>('attributes')

  const onAttributeChange = useCallback(
    newAttribute => {
      const newAttributes = attributes.value.map(a => (a.id === newAttribute.id ? newAttribute : a))

      attributes.onChange(newAttributes)
    },
    [attributes],
  )

  const removeAttribute = useCallback(
    id => {
      const newAttributes = attributes.value.filter(a => a.id !== id)

      attributes.onChange(newAttributes)
    },
    [attributes],
  )

  const addAttribute = useCallback(() => {
    attributes.onChange([...attributes.value, { id: `${Math.random()}`, type: AttributeType.TEXT }])
  }, [attributes])

  return (
    <>
      {attributes.value.length ? (
        <div className={classes.detailsRow}>
          <p className={classes.inputHead}>Attribute Header</p>
          <Field name="attributeHeader">
            {({ input, meta }) => (
              <Input
                placeholder="Header"
                classes={{
                  textField: classes.input,
                }}
                onChange={input.onChange}
                value={input.value}
                fullWidth
                helperText={meta.error}
                error={meta.touched && meta.error}
              />
            )}
          </Field>
        </div>
      ) : null}
      <div>
        {attributes.value.map(a => (
          <Attribute
            attribute={a}
            key={a.id}
            onAttributeChange={onAttributeChange}
            removeAttribute={removeAttribute}
          />
        ))}
      </div>
      <div className={classes.addPrice} onClick={addAttribute}>
        + add attribute
      </div>
    </>
  )
}

export default memo(AttributesSettings)
